/**
 * @namespace {BX.UI}
 */
export default class ButtonIcon
{
	static UNFOLLOW = 'ui-btn-icon-unfollow';
	static FOLLOW = 'ui-btn-icon-follow';
	static ADD = 'ui-btn-icon-add';
	static ADD_M = 'ui-btn-icon-add-m';
	static STOP = 'ui-btn-icon-stop';
	static START = 'ui-btn-icon-start';
	static PAUSE = 'ui-btn-icon-pause';
	static ADD_FOLDER = 'ui-btn-icon-add-folder';
	static SETTING = 'ui-btn-icon-setting';
	static TASK = 'ui-btn-icon-task';
	static INFO = 'ui-btn-icon-info';
	static SEARCH = 'ui-btn-icon-search';
	static PRINT = 'ui-btn-icon-print';
	static LIST = 'ui-btn-icon-list';
	static BUSINESS = 'ui-btn-icon-business';
	static BUSINESS_CONFIRM = 'ui-btn-icon-business-confirm';
	static BUSINESS_WARNING = 'ui-btn-icon-business-warning';
	static CAMERA = 'ui-btn-icon-camera';
	static PHONE_UP = 'ui-btn-icon-phone-up';
	static PHONE_DOWN = 'ui-btn-icon-phone-down';
	static PHONE_CALL = 'ui-btn-icon-phone-call';
	static BACK = 'ui-btn-icon-back';
	static REMOVE = 'ui-btn-icon-remove';
	static DOWNLOAD = 'ui-btn-icon-download';
	static DOTS = 'ui-btn-icon-dots';
	static DONE = 'ui-btn-icon-done';
	static CANCEL = 'ui-btn-icon-cancel';
	static DISK = 'ui-btn-icon-disk';
	static LOCK = 'ui-btn-icon-lock';
	static MAIL = 'ui-btn-icon-mail';
	static CHAT = 'ui-btn-icon-chat';
	static PAGE = 'ui-btn-icon-page';
	static CLOUD = 'ui-btn-icon-cloud';
	static EDIT = 'ui-btn-icon-edit';
	static SHARE = 'ui-btn-icon-share';
	static ANGLE_UP = 'ui-btn-icon-angle-up';
	static ANGLE_DOWN = 'ui-btn-icon-angle-down';
	static EYE_OPENED = 'ui-btn-icon-eye-opened';
	static EYE_CLOSED = 'ui-btn-icon-eye-closed';
	static ALERT = 'ui-btn-icon-alert';
	static FAIL = 'ui-btn-icon-fail';
	static SUCCESS = 'ui-btn-icon-success';
	static PLAN = 'ui-btn-icon-plan';
	static TARIFF = 'ui-btn-icon-tariff';
	static BATTERY = 'ui-btn-icon-battery';
	static NO_BATTERY = 'ui-btn-icon-no-battery';
	static HALF_BATTERY = 'ui-btn-icon-half-battery';
	static LOW_BATTERY = 'ui-btn-icon-low-battery';
	static CRIT_BATTERY = 'ui-btn-icon-crit-battery';
	static DEMO = 'ui-btn-icon-demo';
	static ROBOTS = 'ui-btn-icon-robots';
	static NOTE = 'ui-btn-icon-note';
	static SCRIPT = 'ui-btn-icon-script';
	static PRINT2 = 'ui-btn-icon-print-2';
	static FUNNEL = 'ui-btn-icon-funnel';
	static FORWARD = 'ui-btn-icon-forward';
	static COPY = 'ui-btn-icon-copy';
	static AI = 'ui-btn-icon-ai ui-icon-set__scope';
	static BUSINESS_NEW = 'ui-btn-icon-business-new';
	static OUTLINE_ADD = 'ui-btn-icon-outline-add';
	static HELP = 'ui-btn-icon-help';
	static CHECK = 'ui-btn-icon-check';
	static CHEVRON_LEFT_S = 'ui-btn-icon-chevron-left-s';
	static CHEVRON_RIGHT_S = 'ui-btn-icon-chevron-right-s';
	static REFRESH = 'ui-btn-icon-refresh';
	static APPS = 'ui-btn-icon-apps';
	static IMAGE = 'ui-btn-icon-image';
	static CITY = 'ui-btn-icon-city';
	static TWO_PERSONS = 'ui-btn-icon-two-persons';
	static COPILOT = 'ui-btn-icon-copilot';
	static RELOAD = 'ui-btn-icon-reload';
	static WORKFLOW = 'ui-btn-icon-workflow';
	static PERSON = 'ui-btn-icon-person';
	static WORKFLOW_STOP = 'ui-btn-icon-workflow-stop';
	static MARKET = 'ui-btn-icon-market';
	static KEY = 'ui-btn-icon-key';
	static MAIL_PLUS = 'ui-btn-icon-mail-plus';
	static FUNNEL_FILTER = 'ui-btn-icon-funnel-filter';
	static CALENDAR_WITH_SLOTS = 'ui-btn-icon-calendar-with-slots';
	static CHATS = 'ui-btn-icon-chats';
	static CALENDAR_WITH_CHECKS = 'ui-btn-icon-calendar-with-checks';
	static EXCLAMATION = 'ui-btn-icon-exclamation';
}
